import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Selo de avaliação Google — exibido no rodapé de todas as páginas.
const GoogleRatingBadge = ({ className = '' }) => {
  const [data, setData] = useState({ rating: 5.0, review_count: 46 });

  useEffect(() => {
    fetch(`${API_URL}/api/google-reviews`)
      .then(r => (r.ok ? r.json() : null))
      .then(d => { if (d && d.rating) setData({ rating: d.rating, review_count: d.review_count }); })
      .catch(() => {});
  }, []);

  const rating = Number(data.rating || 5).toFixed(1).replace('.', ',');

  return (
    <Link
      to="/avaliacoes"
      data-testid="google-rating-badge"
      aria-label={`Avaliação ${rating} estrelas no Google com ${data.review_count} avaliações`}
      className={`inline-flex items-center gap-3 px-4 py-2.5 rounded-2xl bg-slate-900/80 border border-slate-700 hover:border-yellow-500/50 shadow-lg shadow-black/20 hover:shadow-yellow-500/10 transition-all hover:-translate-y-0.5 group ${className}`}
    >
      <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
      </svg>
      <div className="flex flex-col leading-tight">
        <div className="flex items-center gap-1.5">
          <span className="text-white font-extrabold text-base">{rating}</span>
          <div className="flex items-center gap-0.5">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 text-yellow-400 fill-yellow-400" />)}
          </div>
        </div>
        <span className="text-slate-400 text-xs group-hover:text-cyan-400 transition-colors">
          {data.review_count} avaliações no Google
        </span>
      </div>
    </Link>
  );
};

export default GoogleRatingBadge;
